<div class="market-selection" [ngClass]="{ 'full-screen': isFullScreen }">
  <div role="main" class="container">
    <h1 data-test-id="marketSelectionHeaderTitle" class="h4">
      {{ config?.header?.title }}
    </h1>
    <p data-test-id="marketSelectionHeaderSubTitle">
      {{ config?.header?.subtitle }}
    </p>

    <section class="market-selection--cards u-flex u-justifyCenter">
      @for (card of config?.cards; track card; let i = $index) {
        <div class="card" (click)="onClick(card)">
          <i
            [attr.data-test-id]="'marketSelectionCardIcon' + i"
            class="icon icon--large icon--link"
            >{{ card.icon }}</i
          >
          <h5 class="h6" [attr.data-test-id]="'marketSelectionCardLabel' + i">
            {{ card.label }}
          </h5>
        </div>
      }
    </section>
  </div>
</div>
